"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GdprHandlerPatterns = void 0;
var GdprHandlerPatterns;
(function (GdprHandlerPatterns) {
    GdprHandlerPatterns["AnonymizeByGdprAnonymize"] = "ANONYMIZE_BY_GDPR_ANONYMIZE";
    GdprHandlerPatterns["AnonymizeUser"] = "AnonymizeUser";
})(GdprHandlerPatterns = exports.GdprHandlerPatterns || (exports.GdprHandlerPatterns = {}));
